import type { AuthUser } from '@/api/models';
import type { Branch } from './components/branchesMeta';

/**
 * Whether this user may open **Import products** for this branch.
 *
 * An OrgAdmin may import into any branch; a BranchAdmin only into the branch
 * their session names (`user.branchId`, the same value the server reads from
 * the token). The server enforces the same scope on every catalog-import call
 * (`BRANCH_NOT_ALLOWED`), so this only decides whether the row menu offers the
 * action: offering it on a branch the server will refuse would lead to a page
 * whose first request fails.
 *
 * Archived branches never offer it. An archived branch cannot trade, so stock
 * imported into it could not be sold, and the server refuses it
 * (`BRANCH_ARCHIVED`).
 *
 * Fails closed: no user, a Seller, or a BranchAdmin with no branch sees nothing.
 */
export const canImportProducts = (
    user: AuthUser | null,
    branch: Pick<Branch, 'id' | 'archived'>,
): boolean => {
    if (!user || branch.archived) {
        return false;
    }
    switch (user.role) {
        case 'OrgAdmin':
            return true;
        case 'BranchAdmin':
            return user.branchId !== null && user.branchId === branch.id;
        default:
            return false;
    }
};
